import { createContext, useContext } from "react"
import type { DateRangeMode, DateRangeValue } from "./dateRangePicker.types"
import type { DateRangePreset } from "./dateRangePicker.utils"

type ActiveEdge = "start" | "end" | null

type DateRangePickerContextValue = {
  mode: DateRangeMode
  start: Date | undefined
  end: Date | undefined
  activeEdge: ActiveEdge
  value?: DateRangeValue
  minDate?: Date
  maxDate?: Date
  changeMode(mode: DateRangeMode): void
  selectRange(range: { start?: Date; end?: Date } | undefined): void
  selectSingle(date: Date | undefined): void
  setActiveEdge(edge: ActiveEdge): void
  commitStart(date: Date): void
  commitEnd(date: Date): void
  apply(): void
  applyPreset(preset: DateRangePreset): void
  clear(): void
  cancel(): void
}

const DateRangePickerContext =
  createContext<DateRangePickerContextValue | null>(null)

export function useDateRangePickerContext() {
  const context = useContext(DateRangePickerContext)
  if (!context) {
    throw new Error(
      "useDateRangePickerContext must be used within a DateRangePicker",
    )
  }
  return context
}

export const DateRangePickerProvider = DateRangePickerContext.Provider
